import styled from '@olxui/core/dist/theme/styled';
import React from 'react';
import {
    Link as UnstyledLink,
    LinkProps as LinkRouterProps
} from 'react-router-dom';

const LinkRouter = styled(UnstyledLink)`
    &:link,
    &:visited,
    &:active {
        color: inherit;
    }

    // Make links receive the same looking outline as for buttons and other focusable elements (Firefox only)
    @supports (-moz-appearance: none) {
        &:focus-visible {
            outline: auto;
        }
    }
`;

export type LinkProps = LinkRouterProps & {
    disabled?: boolean;
};

export const Link = (props: LinkProps) => (
    <LinkRouter role="link" aria-disabled={props.disabled} {...props} />
);

export { UnstyledLink };
